import Preact from 'preact';

var FormStructure = {
  fields: {
    headerLabel: {
      validations: []
    },
    Email: {
      validations: [
        { type: 'regex', pattern: '[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', message: 'Please provide a valid email.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
   },
    FirstName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    LastName: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    TelNumber: {
      validations: [
        { type: 'regex', pattern: '[(]{0,1}[0-9]{3}[) ]{0,2}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}', message: 'Please provide a valid phone number.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    ClientName: {
      validations: []
    },
    AddressLine1: {
      validations: []
    },
    City: {
      validations: []
    },
    State: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Postal: {
      validations: [
        { type: 'maxLength', maxLength: 5, message: 'Enter 5 digit zip code' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EventDate: {
      validations: [
        { type: 'dateinfuture', message: 'Event date must be in the future.' },
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    StartTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    EndTime: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    Theme: {
      validations: [
        { type: 'required', message: 'Please fill in required field.' }
      ]
    },
    PlannedGuestCount: {
      validations: [
        {type: 'regex', pattern: '^[0-9]*$', message: 'Please provide in numbers only.'}
      ]
    },
    Notes: {
      validations: []
    }
  },
  layout: {
    rows: [
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Email:*',
            mapping: 'Email'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'First Name:*',
            mapping: 'FirstName'
      },
      {
            type: 'text',
            size: 'Medium',
            label: 'Last Name:*',
            mapping: 'LastName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Phone Number:*',
            mapping: 'TelNumber'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Company:',
            mapping: 'ClientName'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Address:',
            mapping: 'AddressLine1'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'City:',
            mapping: 'City'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'State:*',
            options: [
              { label: 'AL', value: 'AL' },
              { label: 'AK', value: 'AK' },
              { label: 'AZ', value: 'AZ' },
              { label: 'AR', value: 'AR' },
              { label: 'CA', value: 'CA' },
              { label: 'CO', value: 'CO' },
              { label: 'CT', value: 'CT' },
              { label: 'DE', value: 'DE' },
              { label: 'DC', value: 'DC' },
              { label: 'FL', value: 'FL' },
              { label: 'GA', value: 'GA' },
              { label: 'HI', value: 'HI' },
              { label: 'ID', value: 'ID' },
              { label: 'IL', value: 'IL' },
              { label: 'IN', value: 'IN' },
              { label: 'IA', value: 'IA' },
              { label: 'KS', value: 'KS' },
              { label: 'KY', value: 'KY' },
              { label: 'LA', value: 'LA' },
              { label: 'ME', value: 'ME' },
              { label: 'MD', value: 'MD' },
              { label: 'MA', value: 'MA' },
              { label: 'MI', value: 'MI' },
              { label: 'MN', value: 'MN' },
              { label: 'MS', value: 'MS' },
              { label: 'MO', value: 'MO' },
              { label: 'MT', value: 'MT' },
              { label: 'NE', value: 'NE' },
              { label: 'NV', value: 'NV' },
              { label: 'NH', value: 'NH' },
              { label: 'NJ', value: 'NJ' },
              { label: 'NM', value: 'NM' },
              { label: 'NY', value: 'NY' },
              { label: 'NC', value: 'NC' },
              { label: 'ND', value: 'ND' },
              { label: 'OH', value: 'OH' },
              { label: 'OK', value: 'OK' },
              { label: 'OR', value: 'OR' },
              { label: 'PA', value: 'PA' },
              { label: 'RI', value: 'RI' },
              { label: 'SC', value: 'SC' },
              { label: 'SD', value: 'SD' },
              { label: 'TN', value: 'TN' },
              { label: 'TX', value: 'TX' },
              { label: 'UT', value: 'UT' },
              { label: 'VT', value: 'VT' },
              { label: 'VA', value: 'VA' },
              { label: 'WA', value: 'WA' },
              { label: 'WV', value: 'WV' },
              { label: 'WI', value: 'WI' },
              { label: 'WY', value: 'WY' }
            ],
            mapping: 'State'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Zip Code:*',
            mapping: 'Postal'
          }
        ]
      },
      {
        fields: [
          {
            type: 'date-picker-nofill',
            size: 'Medium',
            label: 'Event Date:*',
            mapping: 'EventDate'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Start Time:*',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'StartTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'End Time:*',
            options: [
              { label: '7:30 AM', value: '07:30:00' },
              { label: '8:00 AM', value: '08:00:00' },
              { label: '8:30 AM', value: '08:30:00' },
              { label: '9:00 AM', value: '09:00:00' },
              { label: '9:30 AM', value: '09:30:00' },
              { label: '10:00 AM', value: '10:00:00' },
              { label: '10:30 AM', value: '10:30:00' },
              { label: '11:00 AM', value: '11:00:00' },
              { label: '11:30 AM', value: '11:30:00' },
              { label: '12:00 PM', value: '12:00:00' },
              { label: '12:30 PM', value: '12:30:00' },
              { label: '1:00 PM', value: '13:00:00' },
              { label: '1:30 PM', value: '13:30:00' },
              { label: '2:00 PM', value: '14:00:00' },
              { label: '2:30 PM', value: '14:30:00' },
              { label: '3:00 PM', value: '15:00:00' },
              { label: '3:30 PM', value: '15:30:00' },
              { label: '4:00 PM', value: '16:00:00' },
              { label: '4:30 PM', value: '16:30:00' },
              { label: '5:00 PM', value: '17:00:00' },
              { label: '5:30 PM', value: '17:30:00' },
              { label: '6:00 PM', value: '18:00:00' },
              { label: '6:30 PM', value: '18:30:00' },
              { label: '7:00 PM', value: '19:00:00' },
              { label: '7:30 PM', value: '19:30:00' },
              { label: '8:00 PM', value: '20:00:00' },
              { label: '8:30 PM', value: '20:30:00' },
              { label: '9:00 PM', value: '21:00:00' },
              { label: '9:30 PM', value: '21:30:00' },
              { label: '10:00 PM', value: '22:00:00' },
              { label: '10:30 PM', value: '22:30:00' },
              { label: '11:00 PM', value: '23:00:00' },
              { label: '11:30 PM', value: '23:30:00' },
              { label: '12:00 AM (next day)', value: '00:00:00' },
              { label: '12:30 AM (next day)', value: '00:30:00' },
              { label: '1:00 AM (next day)', value: '01:00:00' },
              { label: '1:30 AM (next day)', value: '01:30:00' },
              { label: '2:00 AM (next day)', value: '02:00:00' },
              { label: '2:30 AM (next day)', value: '02:30:00' }
            ],
            mapping: 'EndTime'
          }
        ]
      },
      {
        fields: [
          {
            type: 'multiple-choice',
            size: 'Medium',
            label: 'Type Of Event:*',
            options: [
              { label: 'Alumni', value: 'Alumni'},
              { label: 'Bachelor/Bachelorette', value: 'Bachelor/Bachelorette'},
              { label: 'Birthday', value: 'Birthday'},
              { label: 'Cocktail Reception', value: 'Cocktail Reception' },
              { label: 'Corporate Lunch', value: 'Corporate Lunch' },
              { label: 'Engagement', value: 'Engagement' },
              { label: 'Fundraiser', value: 'Fundraiser' },
              { label: 'Graduation', value: 'Graduation' },
              { label: 'Holiday', value: 'Holiday'},
              { label: 'Meeting/Presentation', value: 'Meeting/Presentation' },
              { label: 'Photo/Film Shoot', value: 'Photo/Film Shoot' },
              { label: 'Private Dinner', value: 'Private Dinner' },
              { label: 'Rehearsal Dinner', value: 'Rehearsal Dinner' },
              { label: 'Shower', value: 'Shower' },
              { label: 'Sporting Event', value: 'Sporting Event' },
              { label: 'Wedding', value: 'Wedding' },
              { label: 'Other', value: 'Other' },
            ],
            mapping: 'Theme'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text',
            size: 'Medium',
            label: 'Number of People:*',
            mapping: 'PlannedGuestCount'
          }
        ]
      },
      {
        fields: [
          {
            type: 'text-area',
            size: 'Medium',
            label: 'Additional Informaiton:',
            mapping: 'Notes'
          }
        ]
      },
      {
        fields: [
          {
            type: 'submit',
            size: 'XLarge',
            label: 'Submit'
          }
        ]
      }
    ]
  },
  info: {
    title: 'Laziza Mediterranean Grill Contact Form',
    formId: '1970',
    clientKey: 'CCBDE055-8F53-4B09-9CD8-FBD7A3EB1EF9',
    appKey: '23697F14-AA8C-4622-9F64-FC1A9FF20D0D',
    redirectUrl: '',
    submissionText: 'Thank you! Your web inquiry has been successfully sent. We will contact you within one business day.',
    apiEndpoint: '//api-cec.catereasewebtools.com/inbound-inquiries'
  }
};


export default FormStructure;
